export const problemWithPathGateway = [
  {
    id: "102.80.143.201",
    type: "default",
    position: { x: 290, y: 150 },
    className: "gateway",
    data: { label: "102.80.143.201" },
    dragHandle: "noDrag",
  },
  {
    id: "10.5.112.134",
    type: "default",
    position: { x: 500, y: 185 },
    className: "gateway",
    data: { label: "10.5.112.134" },
    dragHandle: "noDrag",
  },
  {
    id: "71.20.12.201",
    type: "default",
    position: { x: 650, y: 90 },
    className: "gateway",
    data: { label: "71.20.12.201" },
    dragHandle: "noDrag",
  },
  {
    id: "135.156.222.108",
    type: "default",
    position: { x: 770, y: 170 },
    className: "gateway",
    data: { label: "135.156.222.108" },
    dragHandle: "noDrag",
  },
  {
    id: "48.189.46.255",
    type: "default",
    position: { x: 740, y: 383 },
    className: "gateway",
    data: { label: "48.189.46.255" },
    dragHandle: "noDrag",
  },
  {
    id: "25.44.79.53",
    type: "default",
    position: { x: 360, y: 390 },
    className: "gateway",
    data: { label: "25.44.79.53" },
    dragHandle: "noDrag",
  },
  {
    id: "172.251.238.79",
    type: "default",
    position: { x: 530, y: 506 },
    className: "gateway",
    data: { label: "172.251.238.79" },
    dragHandle: "noDrag",
  },
  {
    id: "2.133.220.187",
    type: "default",
    position: { x: 190, y: 300 },
    className: "gateway",
    data: { label: "2.133.220.187" },
    dragHandle: "noDrag",
  },
  {
    id: "159.199.179.144",
    type: "default",
    position: { x: 580, y: 300 },
    className: "gateway",
    data: { label: "159.199.179.144" },
    dragHandle: "noDrag",
  },
  {
    id: "174.175.243.159",
    type: "default",
    position: { x: 640, y: 210 },
    className: "gateway",
    data: { label: "174.175.243.159" },
    dragHandle: "noDrag",
  },
];
